module.exports = __webpack_public_path__ + "img/grapes.4a681da0.svg";